export default __webpack_public_path__ + "static/media/zuz-logo-filled-no.5576349f.png";